import { TOOLTIP_WIDTH_EXPANDED } from './const';
import type { TooltipStyleConfig } from './types';

const baseStyle: TooltipStyleConfig['baseStyle'] = ({ theme }) => ({
  '--popper-arrow-bg': theme.colors.interaction.tooltip,
  zIndex: 'tooltip',
  maxWidth: 40,
  py: 0.25,
  px: 0.75,
  borderRadius: 'sm',
  fontSize: 'md',
  fontWeight: 'medium',
  lineHeight: 'md',
  color: 'feature.onInteraction',
  bg: 'interaction.tooltip',
  boxShadow: 'popover',
});

const VARIANTS = {
  compact: {
    width: 'max-content',
    maxWidth: TOOLTIP_WIDTH_EXPANDED,
  },
  expanded: {
    width: TOOLTIP_WIDTH_EXPANDED,
    py: 1,
    px: 1.5,
    overflowWrap: 'break-word', // allow wrapping
  },
};

export const TOOLTIP_STYLE_CONFIG: TooltipStyleConfig = {
  baseStyle,
  variants: VARIANTS,
};
